interface Config {
  URL_API_GATEWAY: string
  URL_API_LOCAL: string
  API_ACESSO: string
  API_DOCUMENTOS: string
  API_DOMINIOS: string
  API_PESSOAS: string
  API_SIMULACAO_VENDAS: string
  API_REPORTS_GATEWAY: string
  GATEWAY_ACTIVE: boolean
  ENV: string
}

const config: Config = {} as Config

export const loadConfig = async () => {
  try {
    const response = await fetch('/config.json')
    if (!response.ok) {
      throw new Error('Failed to fetch configuration')
    }
    const data = await response.json()
    const env = data.REACT_APP_ENV || 'development'
    Object.assign(config, data[env], { GATEWAY_ACTIVE: data.GATEWAY_ACTIVE, ENV: env })
    if (
      !config.API_ACESSO ||
      !config.API_DOCUMENTOS ||
      !config.API_DOMINIOS ||
      !config.API_PESSOAS ||
      !config.API_SIMULACAO_VENDAS ||
      !config.API_REPORTS_GATEWAY
    ) {
      throw new Error('Critical configuration variables missing.')
    }
  } catch (error) {
    console.error('Error loading config:', error)
  }
}

export default config
